export const theme = {
  colors: {
    // Brand - Primaries
    white: '#FFFFFF',
    black: '#00140F',
    deepForest: '#003D2B',
    paleSpring: '#F2FFC9',
    safepointsGreenLight: '#D8E3B4',

    // Neutrals -> Grays
    grey100: '#F9F7F6',
    grey200: '#F0ECEA',
    grey300: '#DDD8D5',
    grey400: '#BDB8B4',
    grey500: '#9A9795',
    grey600: '#73706E',
    grey700: '#4F4C4A',

    // Shades - Secondaries
    paleSpringLight: '#FAFFE4',
    paleSpringDark: '#C6D1BE',
    deepForestLight: '#E6F1EC',
    deepForestDark: '#002E22',

    // Success
    success: '#30AD36',
    successLight: '#D7F0D9',
    successDark: '#0A3F0D',

    // Error
    error: '#D32E2F',
    errorLight: '#FADADA',
    errorDark: '#4A0B0B',

    // Warning
    warning: '#F57C00',
    warningLight: '#FBE7C6',
    warningDark: '#663D00',

    blueSky: '#24B0FF',

    playground1Dark: '#3D1400',
    playground1Light: '#E5BFAD',
    playground2Dark: '#3D3D00',
    playground2Light: '#E5E5AD',
    playground3Dark: '#003D3D',
    playground3Light: '#ADE5E5',
    playground4Dark: '#00003D',
    playground4Light: '#ADADE5',
    playground5Dark: '#3D003D',
    playground5Light: '#E5ADE5',
    playground6Dark: '#3D0014',
    playground6Light: '#E5ADBF',
    whatsapp: '#25d366',

    transparent: 'transparent',
    backdrop: 'rgba(74, 74, 74, 0.7)',

    // Legacy colors (deprecated - to be removed)
    brandDark: '#003D2B',
    brandDarkMedium: '#3C6D5F',
    brandDarkTransparent: 'rgba(0, 61, 43, 0.05)',
    brandLight: '#ADE6B9',
    brandLime: '#DEF071',
    uiDark: '#00140F',
    uiDarkMedium: 'rgba(0, 20, 15, 0.7)',
    uiDarkDisabled: 'rgba(0, 20, 15, 0.3)',
    uiLight: '#FFFFFF',
    uiLightMedium: 'rgba(255, 255, 255, 0.6)',
    uiLightDisabled: 'rgba(255, 255, 255, 0.38)',
    uiGreyDarkPrimaryHover: '#545454',
    uiGreyDark: '#999999',
    uiGreyMedium: '#DDDDDD',
    uiGreyLight: '#F3F3F3',
    uiGrayUltralight: '#FAFAFA',
    uiGreen: '#009B67',
    uiGreenLight: '#D9F0E8',
    uiGreenMuted: '#A4CCC0',
    uiRed: '#B33636',
    uiRedLight: '#F4E1E1',
    uiRedMuted: '#F7D4D1',
    uiOrange: '#946200',
    uiOrangeLight: '#F4EDE1',
    uiOrangeMuted: '#EDCEB4',
  },
  space: {
    none: 0,
    gutter: 24,
    xxsmall: 4,
    mini: 8,
    xsmall: 10,
    small: 16,
    medium: 20,
    large: 32,
    xlarge: 48,
    xlargeMedium: 64,
    xxlarge: 80,
    xxlargeMedium: 112,
    xxxlarge: 160,
  },
  radii: {
    none: 0,
    xsmall: 2,
    small: 4,
    normal: 8,
    medium: 10,
    large: 20,
    xlarge: 32,
    xxlarge: 40,
    xxxlarge: 50,
  },
  fontSizes: {
    '2xs': 10,
    xs: 12,
    sm: 14,
    base: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 26,
    '4xl': 28,
    '5xl': 30,
    '6xl': 32,
    '7xl': 36,
    '8xl': 38,
    '9xl': 40,
    '10xl': 48,
    '11xl': 60,
    '12xl': 72,
    '13xl': 96,
    '14xl': 128,
  },
  lineHeights: {
    3: 12,
    4: 16,
    5: 18,
    6: 20,
    7: 22,
    8: 24,
    9: 26,
    10: 28,
    11: 30,
    12: 32,
    13: 36,
    14: 40,
    15: 44,
    16: 48,
    17: 52,
    18: 56,
  },
  iconSizes: {
    xsmall: 16,
    small: 24,
    medium: 40,
    large: 64,
    xlarge: 104,
  },
  sizes: {
    header: {
      mobile: 56,
      desktop: 72,
    },
  },
  fontFamily: {
    modernEraRegular: 'ModernEra-Regular',
    modernEraMedium: 'ModernEra-Medium',
    modernEraBold: 'ModernEra-Bold',
    adieuRegular: 'Adieu-Regular',
    adieuBold: 'Adieu-Bold',
    interRegular: 'Inter-Regular',
    interMedium: 'Inter-Medium',
    interSemiBold: 'Inter-Semi-Bold',
  },
} as const

export const breakpoints = {
  XS: 0,
  s: 360,
  M: 768,
  L: 1024,
  XL: 1280,
  XXL: 1440,
}
